var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 126 126",
    style: {
      enableBackground: "new 0 0 126 126"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F2EFEA;stroke:#BFC0C0;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#25CD98;}\r\n\t.st2{fill:#E2062C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123,62.9c0,33.1 -26.8,60-60,60c-10.5,0-20.9-2.8-30-8l-30,8l8-30C-5.5,64.2,4.4,27.5,33.1,11 S98.5,4.4,115,33.1C120.2,42.2,123,52.5,123,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.8,59.9H40.3c-1.7,0-3-1.3-3-3c0-0.8,0.3-1.6,0.9-2.1l22.8-22.8c1.2-1.2,3.1-1.2,4.2,0l22.8,22.8 c1.2,1.2,1.2,3.1,0,4.2C87.3,59.6,86.6,59.9,85.8,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.9,71.1L65.1,93.8c-1.2,1.2-3.1,1.2-4.2,0L38.1,71.1c-1.2-1.2-1.2-3.1,0-4.2c0.6-0.6,1.3-0.9,2.1-0.9h45.5 c1.7,0,3,1.3,3,3C88.8,69.7,88.5,70.5,87.9,71.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bb12a9f87605f5e649211f811d55294f.svg";
export { ForwardRef as ReactComponent };